import { connect } from 'react-redux';

import userPage from 'decorators/userPage';
import UpdateCreator from './UpdateCreator';
import { searchUsers, updateUserCreator } from 'actions/users';
import { getSearchUsers } from 'reducers';

const mapStateToProps = (state) => ({
  users: getSearchUsers(state),
  redirectUrl: (id) => `/users/${id}/view`,
});

const mapDispatchToProps = {
  searchUsers,
  updateUserCreator,
};

export default userPage(
  connect(mapStateToProps, mapDispatchToProps)(UpdateCreator),
);
